const api = `${process.env.REACT_APP_API_ENDPOINT}`
export default api

// login
export const LoginAuth = `${api}account/GetToken`
// login
export const CheckUserDetailsPreLogin = `Service/CheckUserDetailsPreLogin`
export const VerifyPreUserOTP = `Service/VerifyPreUserOTP`
// Master Data Detail
export const GetMasterDataList = `account/GetMasterDataList`
// for city and State
export const GetStateList = `account/GetStateList`
export const GetCityList = `account/GetCityList`
// change password
export const ChangePassword = `account/ChangePassword`
// User Profile
export const GetUserDetailsByRole = `account/GetUserDetailsByRole`
export const GetUserDetails = `account/GetUserDetails`
export const CheckUserPancardDetails = `Service/CheckUserPancardDetails`
export const CheckPinPackageIsValid = `Service/CheckPinPackageIsValid`
export const CreateUser = `account/CreateUser`
export const UpdateUserDetails = `account/UpdateUserDetails`
export const GetUserLotteryDetails = `Service/GetUserLotteryDetails`
// Bank
export const GetBankList = `bank/GetBankList`
export const GetBankDetailsById = `bank/GetBankDetailsById`
export const AddBankDetails = `bank/AddBankDetails`
export const UpdateBankDetails = `bank/UpdateBankDetails`
// Master User Profile
export const GetMasterHelpingIncome = `Service/GetMaster_Helping_Income`
export const AddMasterHelpingIncome = `Service/Add_Master_Helping_Income`
export const UpdateMasterHelpingIncome = `Service/Update_Master_Helping_Income`
// for Binary Data
export const GetGeneoLogyDetails = `Team/GetGeneoLogyDetails`
export const GetLevelDetails = `Team/GetLevelDetails`
export const GetPositionDetails = `Team/GetPositionDetails`
export const GetAutoPoolHierarchy = `Service/GetAutoPoolHierarchy`
export const GetRoyaltyHolders = `Service/GetRoyaltyHolders`
// Package Details
export const GetPackageDetails = `Service/GetPackage_Details`
export const AddPackageDetails = `Service/Add_Package_Details`
export const UpdatePackageDetails = `account/Update_Package_Details`
// Level Income
export const GetMasterLevelIncome = `Service/GetMasterLevelIncome`
export const AddMasterLevelIncome = `Service/Add_Master_LevelIncome`
export const UpdateMasterLevelIncome = `Service/Update_Master_LevelIncome`
// Level Income
export const GetAppConfigKeyDetails = `account/GetAppCongfigKeyDetails`
export const UpdateAppConfigKeyDetails = `account/UpdateAppConfigKeyDetails`
export const GetAppCongfigKeyDetailsPreLogin = `Service/GetAppCongfigKeyDetailsPreLogin`
export const GetAppCongfigKeyDetailsList = `account/GetAppCongfigKeyDetailsList`
// Wallet
export const GetUserCryptoWalletDetails = `Service/Get_UserCryptoWallet_Details`
export const AddUserCryptoWalletDetails = `Service/Add_UserCryptoWallet_Details`
export const UpdateUserCryptoWalletDetails = `Service/Update_UserCryptoWallet_Details`
// Pin Details
export const GetPinDetails = `Service/Get_pin_Details`
export const AddPinDetails = `Service/Add_pin_Details`
export const UpdatePinDetails = `Service/Update_pin_Details`
// Help Link
export const GetLinkDetails = `Service/Get_Link_Details`
export const GetHelpingLinkDetails = `Service/GetHelpingLinkDetails`
export const AddLinkDetails = `Service/Add_Link_Details`
export const UpdateLinkDetails = `Service/Update_Link_Details`
// Income
export const GenerateUserIncome = `Service/GenerateUserIncome`
export const GetWalletIncome = `Service/GetWalletIncome`
export const GenerateWithdrawal = `Service/GenerateWithdrawal`
export const UpdateWithdrawalStatus = `Service/UpdateWithdrawalStatus`
export const GenerateIncomePayout = `Service/GenerateIncomePayout`
export const UpdatePayoutDetails = `Service/Update_Payout_Details`
// Reports
export const GetLedgerDetailsPage = `account/GetLedgerDetailsPage`
export const GetExcelLedgerDetail = `account/GetExcelLedgerDetail`
export const GetPayoutDetails = `Service/Get_Payout_Details`